import { render, staticRenderFns } from "./TaxManager.vue?vue&type=template&id=0a0f8dac&scoped=true"
import script from "./TaxManager.vue?vue&type=script&lang=js"
export * from "./TaxManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0f8dac",
  null
  
)

export default component.exports